export default __webpack_public_path__ + "static/media/rdstation-website.31c960a2.svg";